<template>
  <div id="app" :class="{'is-focus-key': isKeyboardFocussed}">
    <router-view/>
    <SvgSprites/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SvgSprites from '@/components/SvgSprites'

export default {
    name: 'App',
    components: {
        SvgSprites
    },
    data() {
        return {
            isKeyboardFocussed: false,
            lastFocussedTime: new Date().getTime()
        }
    },
    metaInfo() {
        return {
            title: this.$i18n.t('metaInfo:title'),
            meta: [
                { name: 'description', content: this.$i18n.t('metaInfo:description') }
            ]
        }
    },
    methods: {
        ...mapActions('app', [
            'setMetadata'
        ]),
        getCookie(name) {
            const regex = new RegExp(name + '=([^;]*)(;|$)')
            const matchedCookie = regex.exec(document.cookie)
            return (matchedCookie !== null && matchedCookie[1]) ? unescape(matchedCookie[1]) : null
        },
        registerEventListener() {
            document.querySelector('body').addEventListener('keydown', this.toggleKeyboardFocussed)

            document.querySelector('body').addEventListener('click', this.toggleKeyboardFocussed)
        },
        unRegisterEventListener() {
            document.querySelector('body').removeEventListener('keydown', this.toggleKeyboardFocussed)

            document.querySelector('body').removeEventListener('click', this.toggleKeyboardFocussed)
        },
        toggleKeyboardFocussed(e) {
            const currentTime = new Date().getTime()
            if (e.type === 'keydown' && e.key === 'Tab') {
                this.isKeyboardFocussed = true
                this.currentFocussedElem = e.target
            } else if (e.type === 'click' && (currentTime - this.lastFocussedTime >= 500)) {
                this.isKeyboardFocussed = false
            }
            this.lastFocussedTime = currentTime
        }
    },
    mounted() {
        const cookieCampID = this.getCookie('campID')
        if (cookieCampID !== null) {
            this.setMetadata({
                campID: cookieCampID
            })
        }
        this.registerEventListener()
    },
    destroyed() {
        this.unRegisterEventListener()
    }
}
</script>

<style lang="scss">
  @import "assets/scss/app";
</style>
